export type Bonus = {
  number: number
  title: string
  value: string
  badgeClass: string
  image: string
  paragraphs: string[]
  listIntro?: string
  items?: string[]
  note?: string
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'TCM Quick Reference Cards™',
    value: '$47',
    badgeClass: 'bg-gold-400 text-ink',
    image: 'https://cdn.magicpatterns.com/uploads/axN5bk5Gs3Vu5GoidGSM2P/BONUS_1_TCM_EN.png',
    paragraphs: [
      "For the moments when you don't need to read another chapter. You need a quick reference.",
      'These visual cards summarize key TCM identification fields, diagnostic workflow stages, preparation considerations, documentation requirements, and verification checkpoints.',
      'Print them, keep them beside your workbench, or save them on your phone.',
    ],
  },
  {
    number: 2,
    title: 'The 10-Minute TCM Initial Assessment Protocol™',
    value: '$37',
    badgeClass: 'bg-alert-600 text-white',
    image: 'https://cdn.magicpatterns.com/uploads/ue7C5XsJCNhJwaW5Fe24Vp/BONUS_2_TCM_EN.png',
    paragraphs: [
      'A structured worksheet to help you organize the initial assessment of a TCM.',
      'Use it to collect essential information, record the reported symptoms, review the available diagnostic information, identify missing details, and determine an appropriate next step.',
    ],
    note: 'The objective is to make the first ten minutes more structured—not to promise that every TCM fault can be diagnosed in ten minutes.',
  },
  {
    number: 3,
    title: 'The TCM Troubleshooting Case Library™',
    value: '$47',
    badgeClass: 'bg-cta-600 text-white',
    image: 'https://cdn.magicpatterns.com/uploads/qz1QBcV2KNSFQ5eGWerexW/BONUS_3_TCM_EN.png',
    paragraphs: [
      'A collection of structured scenarios covering communication problems, reading failures, programming interruptions, unexpected results, and post-intervention concerns.',
    ],
    listIntro: 'Each case helps you organize:',
    items: [
      'The initial situation.',
      'The information available.',
      'Possible categories of causes.',
      'Relevant checks.',
      'Findings.',
      'The next decision.',
    ],
    note: 'The scenarios are intended to help you practice diagnostic reasoning. Simulated cases are identified as examples rather than presented as verified real-world repairs.',
  },
  {
    number: 4,
    title: 'The TCM Workshop Documentation Kit™',
    value: '$37',
    badgeClass: 'bg-electric-600 text-white',
    image: 'https://cdn.magicpatterns.com/uploads/88rvfkLaADvMNwEGok1wxD/BONUS_4_TCM_EN.png',
    paragraphs: [
      'Ready-to-use templates to organize your TCM jobs.',
      "You'll receive forms for intake, module identification, diagnostic observations, file records, verification, and final reporting.",
      'Instead of creating your own documents from scratch, you can start with a consistent structure and adapt it to your workshop.',
    ],
  },
  {
    number: 5,
    title: 'The 30 TCM Workbench Checklists™',
    value: '$29',
    badgeClass: 'bg-purple-600 text-white',
    image: 'https://cdn.magicpatterns.com/uploads/k5gddP5mB1uV4hb6YPJugL/BONUS_5_TCM_EN.png',
    paragraphs: ['A collection of printable checklists covering the major stages of TCM work.'],
    listIntro: 'Use them to organize:',
    items: [
      'Initial assessment.',
      'Module identification.',
      'Information collection.',
      'Tool selection.',
      'Preparation.',
      'File documentation.',
      'Diagnostic observations.',
      'Verification.',
      'Final reporting.',
    ],
    note: 'Keep them in a workshop binder or consult the digital versions when needed.',
  },
]
